import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pages",
    class: _vm.theme
  }, [_c('n-head'), _c('div', {
    staticClass: "page-body page page-body"
  }, [_c('div', {
    staticClass: "gamecenter page-main",
    class: _vm.isMobile && 'wap',
    attrs: {
      "id": "gamecenter"
    }
  }, [_c('div', {
    staticClass: "gamecenter-banner"
  }, [_c('div', {
    staticClass: "gamecenter-banner-main"
  }, [_c('div', {
    staticClass: "gamecenter-keys"
  }, [_c('div', {
    staticClass: "gamecenter-keys-main"
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang("My Keys")))]), _c('div', {
    staticClass: "gamecenter-keys__value"
  }, [_c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/TAPSTOCK-small.png'),
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm._f("fmt_pre")(_vm.userData.stock)))])])]), _c('div', {
    staticClass: "gamecenter-banner-icon"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/TAPSTOCK-small.png`),
      "alt": ""
    }
  }), _c('svg-icon', {
    attrs: {
      "name": "icon-rightarrow"
    }
  }), _c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/game-small.png`),
      "alt": ""
    }
  }), _c('svg-icon', {
    attrs: {
      "name": "icon-rightarrow"
    }
  }), _c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/USDT-small.png`),
      "alt": ""
    }
  })], 1), _c('div', {
    staticClass: "gamecenter-banner-text"
  }, [_vm._v("Play Games • Get Keys • Win USDT")]), _c('div', {
    staticClass: "gamecenter-keys-btns",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/appcenter');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/game-small.png'),
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.$lang("Spin Now"))), _c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/USDT-small.png'),
      "alt": ""
    }
  })])])]), _c('div', {
    staticClass: "boo"
  }, [_c('div', {
    staticClass: "boo-list"
  }, _vm._l(_vm.gameList, function (item, index) {
    return _c('div', {
      staticClass: "boo-item",
      class: !item.name && 'comingsoon',
      on: {
        "click": function ($event) {
          return _vm.onSkip(item);
        }
      }
    }, [_c('div', {
      staticClass: "boo-icon"
    }, [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    }), _c('div', {
      staticClass: "boo-total"
    }, [item?.user_count > 0 ? _c('span', [_c('img', {
      staticClass: "people",
      attrs: {
        "src": require('@images/tapcoin/new/icon-people.png'),
        "alt": ""
      }
    }), _vm._v(_vm._s(_vm._f("fmt_pre")(item.user_count, 2)))]) : _vm._e()]), item.game_type != 'comingsoon' ? [item?.is_new ? _c('div', {
      staticClass: "new"
    }) : item?.is_hot ? _c('div', {
      staticClass: "hot"
    }) : _vm._e()] : _vm._e()], 2), _c('div', {
      staticClass: "boo-name"
    }, [_vm._v(_vm._s(item.name))])]);
  }), 0)])])]), _c('div', {
    staticClass: "mMenu"
  }, [_c('m-menu')], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };